export const initialState = {
  isFetching: false,
  items: [],
}

export const setItems = (state, payload) => (
  { items: payload, isFetching: false }
)

export const setFetchingStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
